package mainmenu

import apiclient.validations.parseEnumValue
import auth.FeatureFlagStore
import com.tryformation.localization.Translatable
import dev.fritz2.core.RenderContext
import dev.fritz2.core.RootStore
import dev.fritz2.routing.MapRouter
import koin.koinCtx
import koin.withKoin
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.combine
import model.AppPhase
import notifications.notificationComponent
import objectrouting.navigationComponent
import search.global.searchComponent
import twcomponents.twColOf

const val searchMenuContainerId = "searchMenu-container"

enum class SearchMenu : Translatable {
    Page,
    Search,
    Navigation,
    Notifications,
    ;

    override val prefix = "search-menu"
}

class ActiveSearchMenuStore : RootStore<SearchMenu>(DEFAULT, Job()) {

    val routerStore: RouterStore by koinCtx.inject()

    val reset = handle { DEFAULT }

    companion object {
        val DEFAULT = SearchMenu.Search
    }

    init {
        routerStore.data handledBy { route ->
            if (parseEnumValue<Pages>(route["page"]) != Pages.Map) {
                update(SearchMenu.Page)
            } else if (current == SearchMenu.Page) {
                update(SearchMenu.Search)
            }
        }
    }
}

fun RenderContext.searchMenu() {

    withKoin {
        val activeSearchMenuStore: ActiveSearchMenuStore = get()
        val router: MapRouter = get()
        val routerStore: RouterStore = get()
        val appStateStore: AppStateStore = get()
        val featureFlagStore: FeatureFlagStore = get()

        div(
            baseClass = "flex flex-col gap-1 " +
                "w-full md:w-116 md:min-w-100 max-h-full " +
                "z-[1020] md:z-[1009] " +
                "relative top-0 overflow-hidden " + // md:top-2 md:left-2
                "rounded-b-2xl md:rounded-2xl " +
                "bg-formationWhite " +
//                "transition-all duration-300 ease-in-out " +
                "shadow-md" +
                "",
            id = searchMenuContainerId,
        ) {

            twColOf("max-h-full") {
                // Button bar for switching modes (Search, Navigation, Notifications)
                activeSearchMenuStore.data.render { searchMenuEntry ->
                    when (searchMenuEntry) {

                        SearchMenu.Page -> {
                            combine(routerStore.data, appStateStore.data, featureFlagStore.data) { r, a, f -> Triple(a, r, f) }
                                .render { (appState, route, features) ->
                                    when (appState.appPhase) {

                                        AppPhase.LoggedInAnonymous -> {
                                            // page routing for all pages accessible for anonymous users
                                            loggedInRouting(route, router, features, notLoggedInAnonymous = false)
                                        }

                                        AppPhase.LoggedIn -> {
                                            loggedInRouting(route, router, features, notLoggedInAnonymous = true)
                                        }

                                        else -> {}
                                    }
                                }
                        }

                        SearchMenu.Search -> {
                            searchComponent()
                        }

                        SearchMenu.Navigation -> {
                            navigationComponent()
                        }

                        SearchMenu.Notifications -> {
                            notificationComponent()
                        }
                    }
                }
            }
        }
    }
}

